module.exports = __webpack_public_path__ + "img/keith.c24d2668.jpg";